import { render, staticRenderFns } from "./Q14Info.vue?vue&type=template&id=a8f15d14&"
import script from "./Q14Info.vue?vue&type=script&lang=ts&"
export * from "./Q14Info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports